import config from './config';
import request from './request'
import { MessageBox,Message,Loading } from 'element-ui';
import cookie from 'vue-cookies';
import md5 from 'js-md5';
import store from '../store';
import router from '../router';
import moment from 'moment';
import table2excel from 'js-table2excel'

//搜索数组对象key值的 index
export function findIndex(list, key_name, key_value){
    return list.findIndex((v) => {
        return v[key_name] == key_value;
    });
}

//替换
export function replace(txt,old_txt,new_txt){
    return txt.replace(new RegExp(old_txt,("gm")),new_txt)
}

//MD5
export function toMD5(str) {
    return md5(str);
}

//设置Cookie
export function setCookie(key,value) {
    cookie.set(key, value, { path: '/', expires: config.cookie_date });
}
export function setCookieL(key,value) {
    cookie.set(key, value, { path: '/', expires: 9999 });
}
export function getCookie(key) {
    return cookie.get(key);
}
export function clearCookie(key) {
    cookie.set(key, '', { path: '/', expires: -1 });
}

//设置语言Cookie
export function setLang(value) {
    config.i18n.locale = value;
    setCookieL("MY001-LANG",value);
    document.title = config.i18n.tc('sys_name');
}
export function getLang() {
    var lang_key = getCookie("MY001-LANG");
    if(lang_key){
        return lang_key;
    }
    else{
        return config.langs[0].key;
    }
}

//弹框
export function alertErrWait(content) {
    setTimeout(()=>{
        alertErr(content);
    },300);
}
export function alertErr(content,callback = ()=>{}) {
    MessageBox.alert(content,{
        title: config.i18n.tc('err_title'),
        type: 'error',
        lockScroll:false,
        callback: callback
    });
}
export function alertWarning(content) {
    MessageBox.alert(content,{
        title: config.i18n.tc('warn_title'),
        type: 'warning',
    });
}
export function alertInfo(content) {
    MessageBox.alert(content,{
        title: config.i18n.tc('info_title'),
        type: 'info',
    });
}
export function alertSuccess(content,callback = ()=>{}) {
    content = content || config.i18n.tc('op_ok');
    MessageBox.alert(content,{
        title: config.i18n.tc('success_title'),
        type: 'success',
        callback: callback
    });
}
//提示
export function msgSuccess(content) {
    content = content || config.i18n.tc('op_ok');
    Message.success(content,{
        duration: 5000
    });
}
export function msgWarning (content) {
    Message.warning(content,{
        duration: 5000
    });
}
export function msgErr(content) {
    Message.error(content,{
        duration: 8000
    });
}
//选择框
export function confirm(content,okBack,cancelBack,okBackText = null,cancelBackText = null) {
    MessageBox.confirm(content,{
        title: config.i18n.tc('ts_title'),
        confirmButtonText: okBackText || config.i18n.tc('ok'),
        cancelButtonText: cancelBackText || config.i18n.tc('cancel'),
        type: 'warning',
    }).then(() => {
        okBack();
    }).catch(() => {
        if(typeof(cancelBack) == 'function'){
            cancelBack();
        }
    });
}
export function alertImg(src, title, customClass = '') {
    MessageBox.alert("<img style='max-width:80vw;max-height:80vh' src='"+src+"'>",{
        dangerouslyUseHTMLString: true,
        confirmButtonText: config.i18n.tc('close'),
        title: title,
        customClass:customClass
    });
}
//打开图片
export function openImg(img_path) {
    window.open('#/blank/viewer?img_lnk='+img_path,'_blank');
}
//加载中
var el_loading = null;
export function showLoading(title = '') {
    if(!el_loading){
        el_loading = Loading.service({
            background:"rgba(255,255,255,0.1)",
            text: title
        });
    }
    else{
        el_loading.text = title;
    }
}
export function hideLoading() {
    if(el_loading){
        el_loading.close();
        el_loading = null;
    }
}

//跳转
export function linkTo(path,option) {
    router.push({
        path: path,
        query: option
    });
}
export function replaceTo(path,option) {
    router.replace({
        path: path,
        query: option
    });
}
//后退
export function linkBack() {
    router.go(-1);
}
//获取连接path
export function getLinkPath() {
    return router.currentRoute.path;
}
//获取参数
export function getRequest() {
    return router.currentRoute.query;
}

//登录退出
export function setTokenCookie(data) {
    setCookie("MY001-TOKEN-X",data.access_token);
    if(data.last_role_id == ""){
        openRole();
    }
    else{
        setRoleCookie(data);
        replaceTo("/");
    }
}
export function setRoleCookie(data) {
    setCookie("MY001-ORG-ID",data.last_org_id);
    setCookie("MY001-ROLE-ID",data.last_role_id);
}
export function logout() {
    clearCookie("MY001-TOKEN-X");
    clearCookie("MY001-ORG-ID");
    clearCookie("MY001-ROLE-ID");
    clearCookie("MY001-MOD-ID");
    store.commit("clearBaseData_MenuOpens");
    replaceTo("/login");
}
export function getToken() {
    return getCookie("MY001-TOKEN-X");
}
export function getOrgId() {
    return getCookie("MY001-ORG-ID");
}
export function getRoleId() {
    return getCookie("MY001-ROLE-ID");
}
export function setModCat(mod_cat) {
    setCookie("MY001-MOD-CAT", mod_cat);
}
export function getModCat() {
    return getCookie("MY001-MOD-CAT");
}
export function setTheme(theme_key) {
    setCookie("MY001-Theme", theme_key);
}
export function getTheme() {
    return getCookie("MY001-Theme");
}
//列出角色
export function openRole() {
    showLoading();
    request.sendPost("user/role-list",{},(success,data,error)=>{
        hideLoading();
        if(success){
            var text = "<div class='role-box'>";
            data.list.forEach((item)=>{
                text += "<div class='org'><span class='f-bd'>"+item.org_cname+"：</span>";
                text += "<div class='role'>";

                item.roles.forEach((role)=>{
                    text += "<a onclick='changeRole("+role.org_id+","+role.role_id+")'>"+role.role_cname+"</a>"
                });
                text += "</div>";
                text += "</div>";
            });
            text += "</div>";
            MessageBox.alert(text,{
                dangerouslyUseHTMLString: true,
                confirmButtonText: config.i18n.tc('close'),
                title: config.i18n.tc('select_role'),
                customClass: 'width-600'
            });
        }
        else{
            alertErr(error.errmsg);
        }
    });
}
//切换角色
export function changeRole(org_id,role_id) {
    var data = {
        org_id: org_id,
        role_id: role_id
    };
    request.sendPost("user/upd-last-role",data,(success,data,error)=> {
        if (success) {
            MessageBox.close();
            var url = getLinkPath();
            if(url != '/login'){
                setTimeout(()=>{
                    store.commit("setBaseData_baseReload", true);
                    if(url == '/index/welcome'){
                        store.commit("setBaseData_welcomeReload", true);
                    }
                    else{
                        replaceTo("/index/welcome");
                    }
                },500);
            }
            setRoleCookie({last_org_id: org_id,last_role_id: role_id});
            store.commit("clearBaseData_MenuOpens");
        }
        else {
            MessageBox.close();
            setTimeout(()=>{
                alertErr(error.errmsg);
            },500);
        }
    })
}

//设置菜单切换
export function setMenuActiveName() {
    var url = getLinkPath();
    store.commit("setBaseData_Menu", {active_name: url});
}
//设置已开启的菜单
export function setMenuOpens() {
    var url = getLinkPath();
    store.commit("setBaseData_Menu", {active_name: url});
    var para = getRequest();
    if(!para.fn || para.fn == "") return;
    var data = {
        fid: para.fid,
        fn: para.fn,
        path: url,
        url: router.currentRoute.fullPath,
    };
    store.commit("setBaseData_MenuOpens", data);
}

//查询页面初始化
export function listPageInit(self,callback) {
    self.$nextTick(()=>{
        var datearea_id = self.search.datearea_id || 0;
        if(datearea_id > 0){
            var datearea = getDateArea(datearea_id);
            self.search.date_fr = datearea.date_fr;
            self.search.date_to = datearea.date_to;
        }

        callback();
    });
}

//提交审核
export function rwApp(item, url, data, cancel_flag = false) {
    showLoading();
    request.sendPost(url, data, (success, data, error) => {
        hideLoading();
        if(success){
            msgSuccess(error.errmsg);
            if(cancel_flag){
                item.rw_status = 'N';
                item.rw_status_cdesc = '编辑中';
            }
            else{
                item.rw_status = 'W';
                item.rw_status_cdesc = '审核中';
            }
        }
        else {
            alertErr(error.errmsg);
        }
    })
}

//审核通过
export function rw(self, url, confirm_ts = null) {
    confirm_ts = confirm_ts || '您确定要审核通过吗？';
    confirm(confirm_ts,()=>{
        showLoading();
        request.sendPost(url,self.rwData,(success,data,error)=>{
            hideLoading();
            if(success){
                msgSuccess(error.errmsg);
                self.relist = true;
                linkBack();
            }
            else{
                msgErr(error.errmsg);
            }
        });
    });
}

//审核通过
export function noRw(self, url) {
    if(self.rwData.rw_remark == ""){
        alertErr('请输入拒绝通过原因');
        return;
    }
    confirm('您确定要拒绝通过吗？',()=>{
        showLoading();
        request.sendPost(url,self.rwData,(success,data,error)=>{
            hideLoading();
            if(success){
                msgSuccess(error.errmsg);
                self.relist = true;
                linkBack();
            }
            else{
                msgErr(error.errmsg);
            }
        });
    });
}

//公共查询功能
export function list(self,change_page) {
    if (!change_page) {
        self.search.page = 1;
    }
    showLoading(null,0);
    request.sendPost(self.search.search_url, self.search, (success, data, error) => {
        hideLoading();
        if (success) {
            self.listData = data.list;
            self.search.pageSize = parseInt(data.last_page);
            self.totalData.total = data.total.total;
            if(data.total.sum){
                self.totalData.sum = data.total.sum;
            }
        } else {
            alertErr(error.errmsg);
        }
    });
}

//数字
export function regNum() {
    return /^[\-]{0,1}\d+(\.\d+){0,1}$/;
}

//复制对象
export function copyJson(source){
    return JSON.parse(JSON.stringify(source));
}

export function copyTo(text){
    // text是复制文本
    // 创建input元素
    const el = document.createElement('input');
    // 给input元素赋值需要复制的文本
    el.setAttribute('value', text);
    // 将input元素插入页面
    document.body.appendChild(el);
    // 选中input元素的文本
    el.select();
    // 复制内容到剪贴板
    document.execCommand('copy');
    // 删除input元素
    document.body.removeChild(el);

    msgSuccess(config.i18n.tc('copy_ok'));
}

//置空Json
export function clearJson(data){
    for (var key in data) {
        data[key] = '';
    }
}

//以左边(df)为标准填充 左值填充
export function leftJson(df, source){
    var data = {};
    for (var obj in df) {
        if(source[obj] != undefined){
            data[obj] = source[obj];
        }
        else{
            data[obj] = df[obj];
        }
    }
    return data;
}
//根据默认值替换对象 合集填充
export function extendJson(df, source, other = {}){
    var data = {};
    for (var obj in df) {
        data[obj] = df[obj];
    }
    for (var obj in source) {
        data[obj] = source[obj];
    }
    for (var obj in other) {
        data[obj] = other[obj];
    }
    return data;
}

// json 键值互换
export function changeJsonKeyValue(ths) {
    var ss = {};
    for(var key in ths){
        ss[ths[key]] =key;
    }
    return ss;
}

//聚焦文本框
export function inputFocus(txt){
    setTimeout(()=>{
        txt.focus();
    },200);
}

//设置表格高度
export function getTableBoxHeight(table_box_content) {
    var body_height = document.querySelector('#main').clientHeight;
    var table_box_content_top = getOffsetTop(table_box_content);
    return body_height  - table_box_content_top - 62;
}
export function getOffsetTop(el){
    return el.offsetParent
        ? el.offsetTop + getOffsetTop(el.offsetParent)
        : el.offsetTop
}

//获取日期快捷时间
export function getDateArea(index = null) {
    var datearea = [
        {
            text: config.i18n.tc('zdy'),
            date_fr: '',
            date_to: ''
        },
        {
            text: config.i18n.tc('today'),
            date_fr: moment().format("YYYY-MM-DD"),
            date_to: moment().format("YYYY-MM-DD")
        },
        {
            text: config.i18n.tc('yesterday'),
            date_fr: moment().add(-1, 'days').format("YYYY-MM-DD"),
            date_to: moment().add(-1, 'days').format("YYYY-MM-DD")
        },
        {
            text: config.i18n.tc('curr_week'),
            date_fr: moment().startOf('isoWeek').format("YYYY-MM-DD"),
            date_to: moment().endOf('isoWeek').format("YYYY-MM-DD")
        },
        {
            text: config.i18n.tc('before_week'),
            date_fr: moment().add(-1, 'weeks').startOf('isoWeek').format("YYYY-MM-DD"),
            date_to: moment().add(-1, 'weeks').endOf('isoWeek').format("YYYY-MM-DD")
        },
        {
            text: config.i18n.tc('curr_month'),
            date_fr: moment().startOf('month').format("YYYY-MM-DD"),
            date_to: moment().endOf('month').format("YYYY-MM-DD")
        },
        {
            text: config.i18n.tc('before_month'),
            date_fr: moment().add(-1, 'month').startOf('month').format("YYYY-MM-DD"),
            date_to: moment().add(-1, 'month').endOf('month').format("YYYY-MM-DD")
        },
        {
            text: config.i18n.tc('curr_year'),
            date_fr: moment().startOf('year').format("YYYY-MM-DD"),
            date_to: moment().endOf('year').format("YYYY-MM-DD")
        },
        {
            text: config.i18n.tc('before_year'),
            date_fr: moment().add(-1, 'year').startOf('year').format("YYYY-MM-DD"),
            date_to: moment().add(-1, 'year').endOf('year').format("YYYY-MM-DD")
        },
    ];
    if(index != null){
        return datearea[index];
    }
    else{
        return datearea;
    }
}

//获取月份快捷时间
export function getDateMonthArea(index = null) {
    var datearea = [
        {
            text: config.i18n.tc('zdy'),
            date_fr: '',
            date_to: ''
        },
        {
            text: config.i18n.tc('curr_month'),
            date_fr: moment().startOf('month').format("YYYY-MM"),
            date_to: moment().endOf('month').format("YYYY-MM")
        },
        {
            text: config.i18n.tc('before_month'),
            date_fr: moment().add(-1, 'month').startOf('month').format("YYYY-MM"),
            date_to: moment().add(-1, 'month').endOf('month').format("YYYY-MM")
        },
        {
            text: config.i18n.tc('before_month3'),
            date_fr: moment().add(-2, 'month').startOf('month').format("YYYY-MM"),
            date_to: moment().endOf('month').format("YYYY-MM")
        },
        {
            text: config.i18n.tc('before_month4'),
            date_fr: moment().add(-3, 'month').startOf('month').format("YYYY-MM"),
            date_to: moment().endOf('month').format("YYYY-MM")
        },
        {
            text: config.i18n.tc('curr_year'),
            date_fr: moment().startOf('year').format("YYYY-MM"),
            date_to: moment().endOf('year').format("YYYY-MM")
        },
        {
            text: config.i18n.tc('before_year'),
            date_fr: moment().add(-1, 'year').startOf('year').format("YYYY-MM"),
            date_to: moment().add(-1, 'year').endOf('year').format("YYYY-MM")
        },
    ];
    if(index != null){
        return datearea[index];
    }
    else{
        return datearea;
    }
}

//获取星期
export function getWeek (date) { // 参数时间戳
    let week = moment(date).day();
    return config.i18n.tc('week' + week);
}

//获取日历数据
export function getCalendarData(month_no) {
    var end = moment(month_no).daysInMonth();
    let row = 0;
    let col = moment(moment(month_no).format('YYYY-MM-DD')).day() - 1;
    const calendar = [[]];
    let thisDay = 1;
    while (thisDay <= end) {
        var thisDate = moment(month_no).add(thisDay,'d').format('YYYY-MM-DD');
        if (col == 7) {
            row ++;
            col = 0;
            calendar[row] = [{day:thisDay,date:thisDate}];
        } else {
            calendar[row][col] = {day:thisDay,date:thisDate};
        }
        thisDay++;
        col ++;
    }
    var last_row = calendar[calendar.length - 1];
    var add_col = 7 - last_row.length;
    for(var i = 0;i < add_col; i++){
        last_row.push(null);
    }
    return calendar;
}

export function bodyClick() {
    document.body.click();
}

export function getOssImgKey(callback){
    var oss_img_key = store.state.baseData.oss_img_key;
    if(oss_img_key){
        callback(oss_img_key);
    }
    else{
        request.sendPost('com/get-upimg-key?'+Math.random(), {}, (success, data2, error) => {
            if(success){
                var key = {
                    region: data2.region, //地域
                    accessKeyId: data2.accessKeyId, //你自己的key和id
                    accessKeySecret: data2.accessKeySecret,
                    bucket: data2.bucket, //oss上你的存储空间名称
                    dir: data2.dir,
                    secure: true
                }

                store.commit("setBaseData_ossImgKey",key);
                callback(key);
            }
            else{
                alertErr(error.errmsg);
            }
        });
    }
}

//语言
export function textSpeech(msg,sotp_callback = null,rate = 0.8) {
    if(msg.trim() == ""){
        return;
    }
    var u = new SpeechSynthesisUtterance();
    u.lang = 'zh-CN';
    u.rate = rate;
    u.text = msg;
    u.pitch = 1;
    if(sotp_callback){
        u.onend = sotp_callback;
    }
    speechSynthesis.speak(u);
}
export function pauseTextSpeech(pause_flag = true) {
    if(pause_flag){
        speechSynthesis.pause();
    }
    else{
        speechSynthesis.resume();
    }
}
export function stopTextSpeech() {
    speechSynthesis.cancel();
}

//获取时间戳
export function getTime(){
    return new Date().getTime();
}
//获取时间戳
export function timestampToData(time,format = 'YYYY-MM-DD HH:mm'){
    return new moment(time * 1000).format(format);
}
//获取当前日期
export function getNowDate(){
    return moment().format('YYYY-MM-DD');
}
//获取当前日期
export function getNowMonth(){
    return moment().format('YYYY-MM');
}
//获取当前日期
export function getMonthAdd(month_no,month_qty){
    return moment(month_no + '-01').add(month_qty,'months').format('YYYY-MM');
}
export function getDateAdd(date_fr,day_qty){
    return moment(date_fr).add(day_qty,'days').format('YYYY-MM-DD');
}

//门店二维码获取
export function getOrgEwmCode(url,org_id) {
    return url + '?op=org&org_id='+org_id;
}
export function getGoodsEwmCode(url,goods_id,org_id) {
    return url + '?op=goods&goods_id='+goods_id+'&org_id='+org_id;
}

//登陆二维码
export function getLoginEwmCode(scan_code) {
    return config.wxmpBackUrl + '?op=login&scan_code='+scan_code;
}

//导出Excel
export function buildExcelHeader(listHeaders){
    var columns = [];
    listHeaders.forEach((listHeader,index) => {
        var key_px = index>0?'L'+index+'_':'';
        if(!listHeader.listHeaderEx){
            for (var key in listHeader) {
                columns.push({
                    title: listHeader[key],
                    key: key_px + key,
                    type: 'text'
                })
            }
        }
        else{
            var listHeaderEx = listHeader.listHeaderEx;

            for (var key in listHeader) {
                if(key == 'listHeaderEx') break;

                var ex = {type:'text'};
                if(listHeaderEx[key]){
                    ex = listHeaderEx[key];
                }
                columns.push(extendJson({
                        title: listHeader[key],
                        key: key_px + key
                    },ex)
                );
            }
        }
    });
    return columns;
}
export function buildExcelData(list,listHeader,listHeader2,data_key_name2,listHeader3 = null,data_key_name3 = null){
    var data=[];
    list.forEach(item => {
        var temp = {};
        for (var key in listHeader) {
            temp[key] = item[key];
        }
        if(item[data_key_name2].length > 0){
            item[data_key_name2].forEach(item2 => {
                var temp2={};
                for (var key in listHeader2) {
                    temp2['L1_'+key] = item2[key];
                }
                if(listHeader3 && item2[data_key_name3].length > 0){
                    item2[data_key_name3].forEach(item3 => {
                        var temp3={};
                        for (var key in listHeader3) {
                            temp3['L2_'+key] = item3[key];
                        }
                        data.push(extendJson(temp,temp2,temp3));
                        clearJson(temp);
                        clearJson(temp2);
                    });
                }
                else{
                    var temp3 = {};
                    for (var key in listHeader3) {
                        temp3['L2_'+key] = '';
                    }
                    data.push(extendJson(temp,temp2,temp3));
                    clearJson(temp);
                }
            });
        }
        else{
            var temp2 = {};
            for (var key in listHeader2) {
                temp2['L1_'+key] = '';
            }
            var temp3 = {};
            for (var key in listHeader3) {
                temp3['L2_'+key] = '';
            }
            data.push(extendJson(temp,temp2,temp3));
        }
    });
    return data;
}
export function exportExcel(self) {
    var search = copyJson(self.search);
    search.page = 1;
    search.export_flag = 1;
    search.limit = config.export_limit;
    var excel_header = buildExcelHeader([self.listHeader]);
    seedExportExcel(self,search,excel_header);
}
function seedExportExcel(self,search,excel_header) {
    request.sendPost(search.search_url,search,(success,data,error)=>{
        if(success){
            var last_page = data.last_page || -1;
            var export_title = getRequest().fn;

            if(last_page == -1){//无分页
                if(data.length == 0){
                    alertErr(config.i18n.tc('search_nodata'));
                    return;
                }
                table2excel(excel_header, data, export_title);
            }
            else{
                if(search.page == 1 && data.list.length == 0){
                    alertErr(config.i18n.tc('search_nodata'));
                    return;
                }
                export_title = export_title + '(' + search.page + '-' + data.last_page +')';
                table2excel(excel_header, data.list, export_title);
            }

            if(search.page < data.last_page){
                setTimeout(()=> {
                    search.page = parseInt(search.page) + 1;
                    seedExportExcel(self, search, excel_header);
                },800);
            }
        }else{
            alertErr(error.errmsg);
        }
    });
}
export function exportExcelL3(self,data_key_name2,data_key_name3 = null,export_limit = 500) {
    var search = copyJson(self.search);
    search.page = 1;
    search.export_flag = 1;
    search.limit = export_limit;
    var listHeader3 = self.listHeader3 || null;
    var excel_header;
    if(listHeader3){
        excel_header = buildExcelHeader([self.listHeader,self.listHeader2,listHeader3]);
    }
    else{
        excel_header = buildExcelHeader([self.listHeader,self.listHeader2]);
    }
    seedExportExcelL3(self,search,excel_header,data_key_name2,data_key_name3);
}
function seedExportExcelL3(self,search,excel_header,data_key_name2,data_key_name3 = null) {
    request.sendPost(search.search_url,search,(success,data,error)=>{
        if(success){
            var last_page = data.last_page || -1;
            var export_title = getRequest().fn;
            var listHeader3 = self.listHeader3 || null;
            var excel_data = null;

            if(last_page == -1){//无分页
                if(data.length == 0){
                    alertErr(config.i18n.tc('search_nodata'));
                    return;
                }
                excel_data = buildExcelData(data,self.listHeader,self.listHeader2,data_key_name2,listHeader3,data_key_name3);
            }
            else{
                if(search.page == 1 && data.list.length == 0){
                    alertErr(config.i18n.tc('search_nodata'));
                    return;
                }
                export_title = export_title + '(' + search.page + '-' + data.last_page +')';
                excel_data = buildExcelData(data.list,self.listHeader,self.listHeader2,data_key_name2,listHeader3,data_key_name3);
            }
            table2excel(excel_header, excel_data, export_title);

            if(search.page < data.last_page){
                setTimeout(()=> {
                    search.page = parseInt(search.page) + 1;
                    seedExportExcel(self, search, excel_header);
                },800);
            }
        }else{
            alertErr(error.errmsg);
        }
    });
}

//滚动到指定位置
export function goTo(pid,id,top_add = 0) {
    var p = document.querySelector('#'+pid);
    var el = document.querySelector('#'+id);
    if(p && el){
        var el_top = el.offsetTop - top_add;
        p.scrollTo({
            top: el_top, // 指定滚动的位置，单位是像素
            behavior: 'smooth' // 平滑滚动
        });
    }
}

//滚动到指定位置
export function imgErrShowDfImg(e) {
    e.target.src = config.dfImgUrl;
}

//打开窗口
export function openWindow(url) {
    window.open(url, '_blank');
}

//滚动到底部
export function divToDown(div) {
    div.scrollTop = div.scrollHeight;
}

///////////////////////////////////////////////////////////业务级
//检查充值结果
export function chkOrderCharge(order_code,callback,timeout = 15){ //检查订单状态向后台最多请求15次 每秒一次
    timeout --;
    var data = {
        order_code: order_code
    }
    request.sendPost('com/chk-order-charge',data,(success,data,error)=>{
        if(success){ // 有结果
            if(data.order_status == '1' || data.order_status == '3'){ //成功
                callback(data);
            }
            else{ //失败
                hideLoading();
                alertErr('充值结果：'+data.order_status_cdesc);
            }
        }
        else{ // 无结果
            noPayOver(order_code,callback,timeout);
        }
    });
}
export function noPayOver(order_code,callback,timeout){
    if(timeout > 0){
        setTimeout(()=>{
            chkOrderCharge(order_code,callback,timeout);
        },1000);
    }
    else{
        hideLoading();
        alertErr('未获取到充值结果，请前订单管理查看充值结果');
    }
}

export default{
    findIndex,
    replace,
    toMD5,
    setLang,
    getLang,
    getCookie,
    setCookie,
    alertErrWait,
    alertErr,
    alertWarning,
    alertInfo,
    alertSuccess,
    msgErr,
    msgWarning,
    msgSuccess,
    confirm,
    alertImg,
    openImg,
    showLoading,
    hideLoading,
    linkTo,
    replaceTo,
    linkBack,
    getLinkPath,
    getRequest,
    setTokenCookie,
    logout,
    getToken,
    getOrgId,
    getRoleId,
    setModCat,
    getModCat,
    getTheme,
    setTheme,
    openRole,
    changeRole,
    setMenuActiveName,
    setMenuOpens,
    listPageInit,
    rwApp,
    rw,
    noRw,
    list,
    regNum,
    leftJson,
    clearJson,
    extendJson,
    changeJsonKeyValue,
    getTableBoxHeight,
    getOffsetTop,
    getDateArea,
    getDateMonthArea,
    getWeek,
    copyJson,
    copyTo,
    getCalendarData,
    inputFocus,
    bodyClick,
    getOssImgKey,
    textSpeech,
    pauseTextSpeech,
    stopTextSpeech,
    getTime,
    timestampToData,
    getNowDate,
    getNowMonth,
    getMonthAdd,
    getDateAdd,
    getOrgEwmCode,
    getGoodsEwmCode,
    getLoginEwmCode,
    buildExcelHeader,
    exportExcel,
    exportExcelL3,
    goTo,
    imgErrShowDfImg,
    openWindow,
    divToDown,

    ///////////////////////////////////////////////////////业务级
    chkOrderCharge,
    noPayOver
};



// WEBPACK FOOTER //
// ./src/utils/base.js